/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SyncStateRouteImport } from './routes/sync-state'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OwnersRouteImport } from './routes/owners'
import { Route as OwnerCatalogRouteImport } from './routes/owner-catalog'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as MeRouteImport } from './routes/me'
import { Route as ManagerPayersRouteImport } from './routes/manager-payers'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as EmployeesRouteImport } from './routes/employees'
import { Route as DistributorUsersRouteImport } from './routes/distributor-users'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ClientGroupsRouteImport } from './routes/client-groups'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as AuditLogRouteImport } from './routes/audit-log'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TerritoriesIndexRouteImport } from './routes/territories.index'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as Exchange1cIndexRouteImport } from './routes/exchange-1c.index'
import { Route as DistributorsIndexRouteImport } from './routes/distributors.index'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as WelcomeTokenRouteImport } from './routes/welcome.$token'
import { Route as TerritoriesIdRouteImport } from './routes/territories.$id'
import { Route as PlatformSyncEventsRouteImport } from './routes/platform.sync-events'
import { Route as PlatformOrdersRouteImport } from './routes/platform.orders'
import { Route as PlatformAuditLogRouteImport } from './routes/platform.audit-log'
import { Route as OrdersPendingRouteImport } from './routes/orders.pending'
import { Route as Exchange1cEventsRouteImport } from './routes/exchange-1c.events'
import { Route as DistributorsNewRouteImport } from './routes/distributors.new'
import { Route as DistributorsIdRouteImport } from './routes/distributors.$id'
import { Route as ClientsIdRouteImport } from './routes/clients.$id'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as OrdersIdIndexRouteImport } from './routes/orders.$id.index'
import { Route as DistributorsIdIndexRouteImport } from './routes/distributors.$id.index'
import { Route as OrdersIdEditRouteImport } from './routes/orders.$id.edit'
import { Route as DistributorsIdUsersRouteImport } from './routes/distributors.$id.users'
import { Route as DistributorsIdSyncEventsRouteImport } from './routes/distributors.$id.sync-events'
import { Route as DistributorsIdSettingsRouteImport } from './routes/distributors.$id.settings'
import { Route as DistributorsIdOverviewRouteImport } from './routes/distributors.$id.overview'
import { Route as DistributorsIdOrdersRouteImport } from './routes/distributors.$id.orders'
import { Route as DistributorsIdAuditLogRouteImport } from './routes/distributors.$id.audit-log'

const SyncStateRoute = SyncStateRouteImport.update({
  id: '/sync-state',
  path: '/sync-state',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnersRoute = OwnersRouteImport.update({
  id: '/owners',
  path: '/owners',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerCatalogRoute = OwnerCatalogRouteImport.update({
  id: '/owner-catalog',
  path: '/owner-catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagerPayersRoute = ManagerPayersRouteImport.update({
  id: '/manager-payers',
  path: '/manager-payers',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesRoute = EmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorUsersRoute = DistributorUsersRouteImport.update({
  id: '/distributor-users',
  path: '/distributor-users',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientGroupsRoute = ClientGroupsRouteImport.update({
  id: '/client-groups',
  path: '/client-groups',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogRoute = AuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TerritoriesIndexRoute = TerritoriesIndexRouteImport.update({
  id: '/territories/',
  path: '/territories/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const Exchange1cIndexRoute = Exchange1cIndexRouteImport.update({
  id: '/exchange-1c/',
  path: '/exchange-1c/',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorsIndexRoute = DistributorsIndexRouteImport.update({
  id: '/distributors/',
  path: '/distributors/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeTokenRoute = WelcomeTokenRouteImport.update({
  id: '/welcome/$token',
  path: '/welcome/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TerritoriesIdRoute = TerritoriesIdRouteImport.update({
  id: '/territories/$id',
  path: '/territories/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformSyncEventsRoute = PlatformSyncEventsRouteImport.update({
  id: '/platform/sync-events',
  path: '/platform/sync-events',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformOrdersRoute = PlatformOrdersRouteImport.update({
  id: '/platform/orders',
  path: '/platform/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const PlatformAuditLogRoute = PlatformAuditLogRouteImport.update({
  id: '/platform/audit-log',
  path: '/platform/audit-log',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersPendingRoute = OrdersPendingRouteImport.update({
  id: '/orders/pending',
  path: '/orders/pending',
  getParentRoute: () => rootRouteImport,
} as any)
const Exchange1cEventsRoute = Exchange1cEventsRouteImport.update({
  id: '/exchange-1c/events',
  path: '/exchange-1c/events',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorsNewRoute = DistributorsNewRouteImport.update({
  id: '/distributors/new',
  path: '/distributors/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorsIdRoute = DistributorsIdRouteImport.update({
  id: '/distributors/$id',
  path: '/distributors/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIdRoute = ClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIdIndexRoute = OrdersIdIndexRouteImport.update({
  id: '/orders/$id/',
  path: '/orders/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorsIdIndexRoute = DistributorsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DistributorsIdRoute,
} as any)
const OrdersIdEditRoute = OrdersIdEditRouteImport.update({
  id: '/orders/$id/edit',
  path: '/orders/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const DistributorsIdUsersRoute = DistributorsIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DistributorsIdRoute,
} as any)
const DistributorsIdSyncEventsRoute =
  DistributorsIdSyncEventsRouteImport.update({
    id: '/sync-events',
    path: '/sync-events',
    getParentRoute: () => DistributorsIdRoute,
  } as any)
const DistributorsIdSettingsRoute = DistributorsIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DistributorsIdRoute,
} as any)
const DistributorsIdOverviewRoute = DistributorsIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => DistributorsIdRoute,
} as any)
const DistributorsIdOrdersRoute = DistributorsIdOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => DistributorsIdRoute,
} as any)
const DistributorsIdAuditLogRoute = DistributorsIdAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => DistributorsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/catalog': typeof CatalogRoute
  '/client-groups': typeof ClientGroupsRoute
  '/dashboard': typeof DashboardRoute
  '/distributor-users': typeof DistributorUsersRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/manager-payers': typeof ManagerPayersRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/owner-catalog': typeof OwnerCatalogRoute
  '/owners': typeof OwnersRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/sync-state': typeof SyncStateRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/clients/$id': typeof ClientsIdRoute
  '/distributors/$id': typeof DistributorsIdRouteWithChildren
  '/distributors/new': typeof DistributorsNewRoute
  '/exchange-1c/events': typeof Exchange1cEventsRoute
  '/orders/pending': typeof OrdersPendingRoute
  '/platform/audit-log': typeof PlatformAuditLogRoute
  '/platform/orders': typeof PlatformOrdersRoute
  '/platform/sync-events': typeof PlatformSyncEventsRoute
  '/territories/$id': typeof TerritoriesIdRoute
  '/welcome/$token': typeof WelcomeTokenRoute
  '/clients/': typeof ClientsIndexRoute
  '/distributors/': typeof DistributorsIndexRoute
  '/exchange-1c/': typeof Exchange1cIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/territories/': typeof TerritoriesIndexRoute
  '/distributors/$id/audit-log': typeof DistributorsIdAuditLogRoute
  '/distributors/$id/orders': typeof DistributorsIdOrdersRoute
  '/distributors/$id/overview': typeof DistributorsIdOverviewRoute
  '/distributors/$id/settings': typeof DistributorsIdSettingsRoute
  '/distributors/$id/sync-events': typeof DistributorsIdSyncEventsRoute
  '/distributors/$id/users': typeof DistributorsIdUsersRoute
  '/orders/$id/edit': typeof OrdersIdEditRoute
  '/distributors/$id/': typeof DistributorsIdIndexRoute
  '/orders/$id/': typeof OrdersIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/catalog': typeof CatalogRoute
  '/client-groups': typeof ClientGroupsRoute
  '/dashboard': typeof DashboardRoute
  '/distributor-users': typeof DistributorUsersRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/manager-payers': typeof ManagerPayersRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/owner-catalog': typeof OwnerCatalogRoute
  '/owners': typeof OwnersRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/sync-state': typeof SyncStateRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/clients/$id': typeof ClientsIdRoute
  '/distributors/new': typeof DistributorsNewRoute
  '/exchange-1c/events': typeof Exchange1cEventsRoute
  '/orders/pending': typeof OrdersPendingRoute
  '/platform/audit-log': typeof PlatformAuditLogRoute
  '/platform/orders': typeof PlatformOrdersRoute
  '/platform/sync-events': typeof PlatformSyncEventsRoute
  '/territories/$id': typeof TerritoriesIdRoute
  '/welcome/$token': typeof WelcomeTokenRoute
  '/clients': typeof ClientsIndexRoute
  '/distributors': typeof DistributorsIndexRoute
  '/exchange-1c': typeof Exchange1cIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/territories': typeof TerritoriesIndexRoute
  '/distributors/$id/audit-log': typeof DistributorsIdAuditLogRoute
  '/distributors/$id/orders': typeof DistributorsIdOrdersRoute
  '/distributors/$id/overview': typeof DistributorsIdOverviewRoute
  '/distributors/$id/settings': typeof DistributorsIdSettingsRoute
  '/distributors/$id/sync-events': typeof DistributorsIdSyncEventsRoute
  '/distributors/$id/users': typeof DistributorsIdUsersRoute
  '/orders/$id/edit': typeof OrdersIdEditRoute
  '/distributors/$id': typeof DistributorsIdIndexRoute
  '/orders/$id': typeof OrdersIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit-log': typeof AuditLogRoute
  '/catalog': typeof CatalogRoute
  '/client-groups': typeof ClientGroupsRoute
  '/dashboard': typeof DashboardRoute
  '/distributor-users': typeof DistributorUsersRoute
  '/employees': typeof EmployeesRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/manager-payers': typeof ManagerPayersRoute
  '/me': typeof MeRoute
  '/notifications': typeof NotificationsRoute
  '/onboarding': typeof OnboardingRoute
  '/owner-catalog': typeof OwnerCatalogRoute
  '/owners': typeof OwnersRoute
  '/profile': typeof ProfileRoute
  '/settings': typeof SettingsRoute
  '/sync-state': typeof SyncStateRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/clients/$id': typeof ClientsIdRoute
  '/distributors/$id': typeof DistributorsIdRouteWithChildren
  '/distributors/new': typeof DistributorsNewRoute
  '/exchange-1c/events': typeof Exchange1cEventsRoute
  '/orders/pending': typeof OrdersPendingRoute
  '/platform/audit-log': typeof PlatformAuditLogRoute
  '/platform/orders': typeof PlatformOrdersRoute
  '/platform/sync-events': typeof PlatformSyncEventsRoute
  '/territories/$id': typeof TerritoriesIdRoute
  '/welcome/$token': typeof WelcomeTokenRoute
  '/clients/': typeof ClientsIndexRoute
  '/distributors/': typeof DistributorsIndexRoute
  '/exchange-1c/': typeof Exchange1cIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/territories/': typeof TerritoriesIndexRoute
  '/distributors/$id/audit-log': typeof DistributorsIdAuditLogRoute
  '/distributors/$id/orders': typeof DistributorsIdOrdersRoute
  '/distributors/$id/overview': typeof DistributorsIdOverviewRoute
  '/distributors/$id/settings': typeof DistributorsIdSettingsRoute
  '/distributors/$id/sync-events': typeof DistributorsIdSyncEventsRoute
  '/distributors/$id/users': typeof DistributorsIdUsersRoute
  '/orders/$id/edit': typeof OrdersIdEditRoute
  '/distributors/$id/': typeof DistributorsIdIndexRoute
  '/orders/$id/': typeof OrdersIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit-log'
    | '/catalog'
    | '/client-groups'
    | '/dashboard'
    | '/distributor-users'
    | '/employees'
    | '/login'
    | '/logout'
    | '/manager-payers'
    | '/me'
    | '/notifications'
    | '/onboarding'
    | '/owner-catalog'
    | '/owners'
    | '/profile'
    | '/settings'
    | '/sync-state'
    | '/auth/callback'
    | '/clients/$id'
    | '/distributors/$id'
    | '/distributors/new'
    | '/exchange-1c/events'
    | '/orders/pending'
    | '/platform/audit-log'
    | '/platform/orders'
    | '/platform/sync-events'
    | '/territories/$id'
    | '/welcome/$token'
    | '/clients/'
    | '/distributors/'
    | '/exchange-1c/'
    | '/orders/'
    | '/territories/'
    | '/distributors/$id/audit-log'
    | '/distributors/$id/orders'
    | '/distributors/$id/overview'
    | '/distributors/$id/settings'
    | '/distributors/$id/sync-events'
    | '/distributors/$id/users'
    | '/orders/$id/edit'
    | '/distributors/$id/'
    | '/orders/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit-log'
    | '/catalog'
    | '/client-groups'
    | '/dashboard'
    | '/distributor-users'
    | '/employees'
    | '/login'
    | '/logout'
    | '/manager-payers'
    | '/me'
    | '/notifications'
    | '/onboarding'
    | '/owner-catalog'
    | '/owners'
    | '/profile'
    | '/settings'
    | '/sync-state'
    | '/auth/callback'
    | '/clients/$id'
    | '/distributors/new'
    | '/exchange-1c/events'
    | '/orders/pending'
    | '/platform/audit-log'
    | '/platform/orders'
    | '/platform/sync-events'
    | '/territories/$id'
    | '/welcome/$token'
    | '/clients'
    | '/distributors'
    | '/exchange-1c'
    | '/orders'
    | '/territories'
    | '/distributors/$id/audit-log'
    | '/distributors/$id/orders'
    | '/distributors/$id/overview'
    | '/distributors/$id/settings'
    | '/distributors/$id/sync-events'
    | '/distributors/$id/users'
    | '/orders/$id/edit'
    | '/distributors/$id'
    | '/orders/$id'
  id:
    | '__root__'
    | '/'
    | '/audit-log'
    | '/catalog'
    | '/client-groups'
    | '/dashboard'
    | '/distributor-users'
    | '/employees'
    | '/login'
    | '/logout'
    | '/manager-payers'
    | '/me'
    | '/notifications'
    | '/onboarding'
    | '/owner-catalog'
    | '/owners'
    | '/profile'
    | '/settings'
    | '/sync-state'
    | '/auth/callback'
    | '/clients/$id'
    | '/distributors/$id'
    | '/distributors/new'
    | '/exchange-1c/events'
    | '/orders/pending'
    | '/platform/audit-log'
    | '/platform/orders'
    | '/platform/sync-events'
    | '/territories/$id'
    | '/welcome/$token'
    | '/clients/'
    | '/distributors/'
    | '/exchange-1c/'
    | '/orders/'
    | '/territories/'
    | '/distributors/$id/audit-log'
    | '/distributors/$id/orders'
    | '/distributors/$id/overview'
    | '/distributors/$id/settings'
    | '/distributors/$id/sync-events'
    | '/distributors/$id/users'
    | '/orders/$id/edit'
    | '/distributors/$id/'
    | '/orders/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditLogRoute: typeof AuditLogRoute
  CatalogRoute: typeof CatalogRoute
  ClientGroupsRoute: typeof ClientGroupsRoute
  DashboardRoute: typeof DashboardRoute
  DistributorUsersRoute: typeof DistributorUsersRoute
  EmployeesRoute: typeof EmployeesRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ManagerPayersRoute: typeof ManagerPayersRoute
  MeRoute: typeof MeRoute
  NotificationsRoute: typeof NotificationsRoute
  OnboardingRoute: typeof OnboardingRoute
  OwnerCatalogRoute: typeof OwnerCatalogRoute
  OwnersRoute: typeof OwnersRoute
  ProfileRoute: typeof ProfileRoute
  SettingsRoute: typeof SettingsRoute
  SyncStateRoute: typeof SyncStateRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  ClientsIdRoute: typeof ClientsIdRoute
  DistributorsIdRoute: typeof DistributorsIdRouteWithChildren
  DistributorsNewRoute: typeof DistributorsNewRoute
  Exchange1cEventsRoute: typeof Exchange1cEventsRoute
  OrdersPendingRoute: typeof OrdersPendingRoute
  PlatformAuditLogRoute: typeof PlatformAuditLogRoute
  PlatformOrdersRoute: typeof PlatformOrdersRoute
  PlatformSyncEventsRoute: typeof PlatformSyncEventsRoute
  TerritoriesIdRoute: typeof TerritoriesIdRoute
  WelcomeTokenRoute: typeof WelcomeTokenRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  DistributorsIndexRoute: typeof DistributorsIndexRoute
  Exchange1cIndexRoute: typeof Exchange1cIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  TerritoriesIndexRoute: typeof TerritoriesIndexRoute
  OrdersIdEditRoute: typeof OrdersIdEditRoute
  OrdersIdIndexRoute: typeof OrdersIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sync-state': {
      id: '/sync-state'
      path: '/sync-state'
      fullPath: '/sync-state'
      preLoaderRoute: typeof SyncStateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owners': {
      id: '/owners'
      path: '/owners'
      fullPath: '/owners'
      preLoaderRoute: typeof OwnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owner-catalog': {
      id: '/owner-catalog'
      path: '/owner-catalog'
      fullPath: '/owner-catalog'
      preLoaderRoute: typeof OwnerCatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manager-payers': {
      id: '/manager-payers'
      path: '/manager-payers'
      fullPath: '/manager-payers'
      preLoaderRoute: typeof ManagerPayersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees': {
      id: '/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributor-users': {
      id: '/distributor-users'
      path: '/distributor-users'
      fullPath: '/distributor-users'
      preLoaderRoute: typeof DistributorUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client-groups': {
      id: '/client-groups'
      path: '/client-groups'
      fullPath: '/client-groups'
      preLoaderRoute: typeof ClientGroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-log': {
      id: '/audit-log'
      path: '/audit-log'
      fullPath: '/audit-log'
      preLoaderRoute: typeof AuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/territories/': {
      id: '/territories/'
      path: '/territories'
      fullPath: '/territories/'
      preLoaderRoute: typeof TerritoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchange-1c/': {
      id: '/exchange-1c/'
      path: '/exchange-1c'
      fullPath: '/exchange-1c/'
      preLoaderRoute: typeof Exchange1cIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributors/': {
      id: '/distributors/'
      path: '/distributors'
      fullPath: '/distributors/'
      preLoaderRoute: typeof DistributorsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome/$token': {
      id: '/welcome/$token'
      path: '/welcome/$token'
      fullPath: '/welcome/$token'
      preLoaderRoute: typeof WelcomeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/territories/$id': {
      id: '/territories/$id'
      path: '/territories/$id'
      fullPath: '/territories/$id'
      preLoaderRoute: typeof TerritoriesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/sync-events': {
      id: '/platform/sync-events'
      path: '/platform/sync-events'
      fullPath: '/platform/sync-events'
      preLoaderRoute: typeof PlatformSyncEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/orders': {
      id: '/platform/orders'
      path: '/platform/orders'
      fullPath: '/platform/orders'
      preLoaderRoute: typeof PlatformOrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/audit-log': {
      id: '/platform/audit-log'
      path: '/platform/audit-log'
      fullPath: '/platform/audit-log'
      preLoaderRoute: typeof PlatformAuditLogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/pending': {
      id: '/orders/pending'
      path: '/orders/pending'
      fullPath: '/orders/pending'
      preLoaderRoute: typeof OrdersPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exchange-1c/events': {
      id: '/exchange-1c/events'
      path: '/exchange-1c/events'
      fullPath: '/exchange-1c/events'
      preLoaderRoute: typeof Exchange1cEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributors/new': {
      id: '/distributors/new'
      path: '/distributors/new'
      fullPath: '/distributors/new'
      preLoaderRoute: typeof DistributorsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributors/$id': {
      id: '/distributors/$id'
      path: '/distributors/$id'
      fullPath: '/distributors/$id'
      preLoaderRoute: typeof DistributorsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$id': {
      id: '/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof ClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$id/': {
      id: '/orders/$id/'
      path: '/orders/$id'
      fullPath: '/orders/$id/'
      preLoaderRoute: typeof OrdersIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributors/$id/': {
      id: '/distributors/$id/'
      path: '/'
      fullPath: '/distributors/$id/'
      preLoaderRoute: typeof DistributorsIdIndexRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/orders/$id/edit': {
      id: '/orders/$id/edit'
      path: '/orders/$id/edit'
      fullPath: '/orders/$id/edit'
      preLoaderRoute: typeof OrdersIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/distributors/$id/users': {
      id: '/distributors/$id/users'
      path: '/users'
      fullPath: '/distributors/$id/users'
      preLoaderRoute: typeof DistributorsIdUsersRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/distributors/$id/sync-events': {
      id: '/distributors/$id/sync-events'
      path: '/sync-events'
      fullPath: '/distributors/$id/sync-events'
      preLoaderRoute: typeof DistributorsIdSyncEventsRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/distributors/$id/settings': {
      id: '/distributors/$id/settings'
      path: '/settings'
      fullPath: '/distributors/$id/settings'
      preLoaderRoute: typeof DistributorsIdSettingsRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/distributors/$id/overview': {
      id: '/distributors/$id/overview'
      path: '/overview'
      fullPath: '/distributors/$id/overview'
      preLoaderRoute: typeof DistributorsIdOverviewRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/distributors/$id/orders': {
      id: '/distributors/$id/orders'
      path: '/orders'
      fullPath: '/distributors/$id/orders'
      preLoaderRoute: typeof DistributorsIdOrdersRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
    '/distributors/$id/audit-log': {
      id: '/distributors/$id/audit-log'
      path: '/audit-log'
      fullPath: '/distributors/$id/audit-log'
      preLoaderRoute: typeof DistributorsIdAuditLogRouteImport
      parentRoute: typeof DistributorsIdRoute
    }
  }
}

interface DistributorsIdRouteChildren {
  DistributorsIdAuditLogRoute: typeof DistributorsIdAuditLogRoute
  DistributorsIdOrdersRoute: typeof DistributorsIdOrdersRoute
  DistributorsIdOverviewRoute: typeof DistributorsIdOverviewRoute
  DistributorsIdSettingsRoute: typeof DistributorsIdSettingsRoute
  DistributorsIdSyncEventsRoute: typeof DistributorsIdSyncEventsRoute
  DistributorsIdUsersRoute: typeof DistributorsIdUsersRoute
  DistributorsIdIndexRoute: typeof DistributorsIdIndexRoute
}

const DistributorsIdRouteChildren: DistributorsIdRouteChildren = {
  DistributorsIdAuditLogRoute: DistributorsIdAuditLogRoute,
  DistributorsIdOrdersRoute: DistributorsIdOrdersRoute,
  DistributorsIdOverviewRoute: DistributorsIdOverviewRoute,
  DistributorsIdSettingsRoute: DistributorsIdSettingsRoute,
  DistributorsIdSyncEventsRoute: DistributorsIdSyncEventsRoute,
  DistributorsIdUsersRoute: DistributorsIdUsersRoute,
  DistributorsIdIndexRoute: DistributorsIdIndexRoute,
}

const DistributorsIdRouteWithChildren = DistributorsIdRoute._addFileChildren(
  DistributorsIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditLogRoute: AuditLogRoute,
  CatalogRoute: CatalogRoute,
  ClientGroupsRoute: ClientGroupsRoute,
  DashboardRoute: DashboardRoute,
  DistributorUsersRoute: DistributorUsersRoute,
  EmployeesRoute: EmployeesRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ManagerPayersRoute: ManagerPayersRoute,
  MeRoute: MeRoute,
  NotificationsRoute: NotificationsRoute,
  OnboardingRoute: OnboardingRoute,
  OwnerCatalogRoute: OwnerCatalogRoute,
  OwnersRoute: OwnersRoute,
  ProfileRoute: ProfileRoute,
  SettingsRoute: SettingsRoute,
  SyncStateRoute: SyncStateRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  ClientsIdRoute: ClientsIdRoute,
  DistributorsIdRoute: DistributorsIdRouteWithChildren,
  DistributorsNewRoute: DistributorsNewRoute,
  Exchange1cEventsRoute: Exchange1cEventsRoute,
  OrdersPendingRoute: OrdersPendingRoute,
  PlatformAuditLogRoute: PlatformAuditLogRoute,
  PlatformOrdersRoute: PlatformOrdersRoute,
  PlatformSyncEventsRoute: PlatformSyncEventsRoute,
  TerritoriesIdRoute: TerritoriesIdRoute,
  WelcomeTokenRoute: WelcomeTokenRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  DistributorsIndexRoute: DistributorsIndexRoute,
  Exchange1cIndexRoute: Exchange1cIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  TerritoriesIndexRoute: TerritoriesIndexRoute,
  OrdersIdEditRoute: OrdersIdEditRoute,
  OrdersIdIndexRoute: OrdersIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
